import { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import GeneratorControlSection from 'src/components/Generator/GeneratorControlSection'
import { useTaskSubmitFormContext } from '../../../BaseTaskSubmitForm'
import { DEFAULT_XL_SIZE } from '../../constants'
import { SidebarButtonGroup } from './sidebar'
import { useSizeConfig } from './useSizeConfig'

export { SizeInput } from './modal'

export default function ImageSizeControl() {
  const { t } = useTranslation(['artwork'])

  return (
    <GeneratorControlSection title={t('generation:size.aspect-ratio.label')}>
      <TaskSizeSelect />
    </GeneratorControlSection>
  )
}

function TaskSizeSelect() {
  const {
    values: { width, height, modelId },
    setValues,
  } = useTaskSubmitFormContext()
  const { defaultSize, isApiDriven, isLoading } = useSizeConfig(modelId)

  useEffect(() => {
    if (isLoading) return

    if (!width || !height) {
      const fallback =
        isApiDriven && defaultSize ? defaultSize : DEFAULT_XL_SIZE
      setValues(prev => ({
        ...prev,
        width: prev.width || fallback.width,
        height: prev.height || fallback.height,
      }))
    }
  }, [width, height, setValues, isApiDriven, isLoading, defaultSize])

  return (
    <div className="flex flex-col gap-2">
      <SidebarButtonGroup />
    </div>
  )
}
